module.exports = __webpack_public_path__ + "static/media/logo-small.1641ce83.svg";